<template>
  <div id="app">
      	<router-view/>
  </div>
</template>

<script>
// 状态管理
import {mapState,mapGetters,mapMutations,mapActions} from 'vuex';
// 状态管理变量名
import * as types from '@/store/types.js';
import {EventBus} from '@/util/eventBus.js';
export default {
	name: 'App',
	data () {
		return {
			title:'华夏移民',
			keyWords:'华夏移民',
			description:'华夏移民'
		}
	},
	methods:{
		// 书本信息action
		...mapActions({
			initSeo:types.MAKE_SET_SEO
		}),
    toKefuFun() {
      $('#nb_icon_wrap').trigger("click");
      // this.isShangqiao = true;
      // window.open('http://p.qiao.baidu.com/cps/chat?siteId=16651794&userId=32933850&siteToken=b01bbd89a91c1afb1c917e9f705d7706', 'newwindow', 'height=600, width=900, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no');
    }
	},
  	computed:{
		...mapGetters({
			//本地用户信息
			seoInfo:types.MAKE_GET_SEO
		})
	},
	created(){
		this.initSeo({}).then(ob => {
		// axios结果处理
		});
		const that = this
    // 显示遮罩事件
    EventBus.$on('toEventbusKefuFun',function(){
      that.toKefuFun();
    })
	},
	metaInfo(){
	  	return {
		    title: this.seoInfo.title?this.seoInfo.title:'华夏移民', // set a title
		    meta: [{             // set meta
		      name: 'keyWords',
		      content: this.seoInfo.keywords?this.seoInfo.keywords:'华夏移民'
		    },
		    {
		      name: 'description',
		      content: this.seoInfo.description?this.seoInfo.description:'华夏移民'
		    }]
		 }
	}
}
</script>

<!-- <style scoped src="styles/page.css"></style> -->
<style scoped>
	#app{
		height:100%;
		background:#FFF;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue